<script>
</script>

<oc-block-v2
	style="--custom-spacing-y: 0px; --custom-spacing-x: 0px;"
	id="free-shipping-banner"
	data-testid="free-shipping-banner"
>
	<div class="free-shipping-banner oc-copy-100">
		<oc-icon-v1 data-testid="icon_delivery-flat" class="oc-mr-100 free-shipping-banner__icon" aria-hidden="true"
			type="delivery-flat"></oc-icon-v1>
		<strong>GRATIS Versand</strong>
		<oc-tag-v1
			class="free-shipping-banner__tag"
			variant="custom-color-soft"
			size="50"
		>
			Inklusive
		</oc-tag-v1>
	</div>
</oc-block-v2>

<style lang="scss">
  .free-shipping-banner {
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 16px;

    &__icon {
      background-color: var(--oc-semantic-color-text-default)
    }
		&__tag {
			margin-left: 8px;
      --background-color: var(--oc-semantic-color-background-soft-mint)
		}
  }
</style>